import React from 'react';
import { Button, ButtonGroup, ClickAwayListener, Grow, IconButton, MenuList, Paper, Popper, SxProps } from '@mui/material';

import MuiIcon from '../../styles/mui/helpers/mui-icon.helper';
import { TMuiSize } from '../../styles/mui/contracts/TMuiSize';
import { TMuiButtonColor } from '../../styles/mui/contracts/TMuiColor';
import { TMuiButtonVariant } from '../../styles/mui/contracts/TMuiButtonVariant';
import MuiSxStyles from '../../styles/mui/MuiSx.styles';


interface IProps {

  buttonIcon?: React.ReactNode;
  menuButtonIcon?: React.ReactNode;

  text: string;
  onClick?: () => void;
  sx?: SxProps;

  children: React.ReactNode;
  size?: TMuiSize;
  menuMinWidth?: string;
  menuButtonWidth?: string;
  menuButtonText?: string;

  disabled?: boolean;
  buttonDisabled?: boolean;
  menuButtonDisabled?: boolean;

  variant?: TMuiButtonVariant;
  buttonVariant?: TMuiButtonVariant;
  menuButtonVariant?: TMuiButtonVariant;

  color?: TMuiButtonColor,
  buttonColor?: TMuiButtonColor,
  menuButtonColor?: TMuiButtonColor,
}
function MenuButtonComponent({
  children, sx = {}, buttonIcon, menuButtonIcon = MuiIcon.ARROW_DROP_DOWN(), text, onClick = () => { },
  menuMinWidth = '118px', menuButtonText, menuButtonWidth = '32px', size = 'medium',
  disabled = false, buttonDisabled = false, menuButtonDisabled = false,
  color = 'primary', buttonColor, menuButtonColor,
  variant = 'outlined', buttonVariant, menuButtonVariant,

}: IProps) {

  const [open, setOpen] = React.useState(false);
  const anchorRef = React.useRef<HTMLDivElement>(null);

  const handleToggle = () => {
    setOpen((prevOpen) => !prevOpen);
  };

  const handleClose = (event: Event) => {
    if (anchorRef.current && anchorRef.current.contains(event.target as HTMLElement)) {
      return;
    }
    setOpen(false);
  };

  return (<React.Fragment>
    <ButtonGroup sx={sx} size={size} disabled={disabled || (buttonDisabled && menuButtonDisabled)} variant={variant} ref={anchorRef} color={color}>
      <Button sx={{ borderRadius: '24px' }} startIcon={buttonIcon} color={buttonColor || color} variant={buttonVariant || variant} disabled={buttonDisabled} onClick={onClick}>{text}</Button>
      {menuButtonText || <Button sx={{ borderRadius: '24px', width: menuButtonWidth }} color={menuButtonColor || color} variant={menuButtonVariant || variant} size="small" disabled={menuButtonDisabled} onClick={handleToggle}>{menuButtonIcon}</Button>}
      {menuButtonText && <Button sx={{ borderRadius: '24px' }} color={menuButtonColor || color} variant={menuButtonVariant || variant} disabled={menuButtonDisabled} onClick={handleToggle}
        endIcon={menuButtonIcon}>{menuButtonText}</Button>}
      {/* <IconButton color={menuButtonColor || color} size={'small'} disabled={menuButtonDisabled} onClick={handleToggle}>{menuButtonIcon}</IconButton> */}
    </ButtonGroup>
    <Popper sx={{ zIndex: 1, backgroundColor: (t) => '#FFF' }} open={open} anchorEl={anchorRef.current} role={undefined} transition disablePortal >
      {({ TransitionProps, placement }) => (
        <Grow {...TransitionProps} style={{ transformOrigin: placement === 'bottom' ? 'center top' : 'center bottom' }}>
          <Paper sx={{ ...MuiSxStyles.frostedGlassMenu, minWidth: menuMinWidth }}>
            <ClickAwayListener onClickAway={handleClose}>
              <MenuList autoFocusItem>
                {children}
              </MenuList>
            </ClickAwayListener>
          </Paper>
        </Grow>
      )}
    </Popper>
  </React.Fragment>)
}
export default MenuButtonComponent;